module.exports = __webpack_public_path__ + "static/media/Residential_11.25369cc8.jpg";